/*
 * 新看板--维护中设备数据--维护中设备数据明细
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Table } from "antd";

class MaintenanceDevicesDetailDetail extends Component {
  state = {
    tableColumns: [
      {
        title: "地区",
        dataIndex: "provinceName",
        key: "provinceName",
        align: "center",
      },
      {
        title: "设备数量",
        dataIndex: "num",
        key: "num",
        align: "center",
      },
      {
        title: "设备占比",
        dataIndex: "rate",
        key: "rate",
        align: "center",
        render: (text) => {
          return `${text}%`;
        },
      },
    ],
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50"],
      showTotal: (total) => `共 ${total} 条记录`,
      onChange: (page, pageSize) => {
        this.setState({
          pagination: {
            ...this.state.pagination,
            current: page,
            pageSize: pageSize,
          },
        });
      },
      onShowSizeChange: (current, pageSize) => {
        this.setState({
          pagination: {
            ...this.state.pagination,
            current: 1,
            pageSize: pageSize,
          },
        });
      },
    },
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    console.log(this.context.store.getState().modalInfo.param);
    const { totalCount, dataSource } = this.context.store.getState().modalInfo.param;
    return (
      <div>
        <h3>总数值：{totalCount}</h3>
        <Table
          dataSource={dataSource || []}
          columns={this.state.tableColumns}
          pagination={{
            ...this.state.pagination,
            total: dataSource ? dataSource.length : 0,
          }}
        />
      </div>
    );
  }
}

export default MaintenanceDevicesDetailDetail;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/maintenanceDevicesDetail.js